/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { Link } from "wouter";
import "./HeaderRouteIndicator.scss";

const HeaderRouteIndicator = ({ route }) => {
	return (
		<div className="newsHeaderIndicator-container">
			<div className="max-width flex newsHeaderIndicator-text-container all-width-height">
				{!Array.isArray(route) ? (
					<h5 className="bold c-dark-blue">{route}</h5>
				) : (
					route.map((element, index) => (
						<>
							{element.route ? (
								<Link href={element.route}>
									<a className="bold c-dark-blue headerRouteIndicator--anchor">
										{element.text}
									</a>
								</Link>
							) : (
								<h5 className="bold c-dark-blue">{element.text}</h5>
							)}
							{(index === 0 || index === 1) && <span>&nbsp;/&nbsp;</span>}
						</>
					))
				)}
			</div>
		</div>
	);
};

export default HeaderRouteIndicator;
